import React, { PureComponent } from "react";
import DecisionsWrapper from "../components/decisions/wrapper";
import { batchRequest } from "../api/ApiService";
import {
  getSubmissionRequest,
  handleSubmission,
  submitDecisions
} from "../api/SubmitDecisions";
import Auth from "../routes/Auth";

function capitalizeFirstLetter(s) {
  return s.charAt(0).toUpperCase() + s.slice(1);
}

class DecisionsSummary extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      submission_data: {
        pd: {
          date: "N/A",
          unaccepted: 0
        },
        pm: {
          date: "N/A",
          unaccepted: 0
        },
        op: {
          date: "N/A",
          unaccepted: 0
        },
        fn: {
          date: "N/A",
          unaccepted: 0
        }
      },
      submitDecisionsLoadingDevelopment: false,
      submitDecisionsLoadingMarketing: false,
      submitDecisionsLoadingOperations: false,
      submitDecisionsLoadingFinance: false,
      hasAccess: Auth.getRole() === "CEO"
    };
  }

  componentDidMount() {
    //this.fetchData()
  }

  fetchData = () => {
    const { rounds, currentRound } = this.props;

    if (rounds.length === 0) {
      return;
    }

    const round = rounds.find(i => i.number === currentRound);
    if (!round) {
      return;
    }

    const joinRequest = batchRequest([
      ...getSubmissionRequest(
        ["pd", "pm", "op", "fn"],
        currentRound,
        round.is_finished
      )
    ]);

    joinRequest
      .then(res => {
        const submission_data = handleSubmission(
          ["pd", "pm", "op", "fn"],
          [
            res[0].body,
            res[1].body,
            res[2].body,
            res[3].body,
            res[4].body
          ],
          round.is_finished
        );

        this.setState({
          submission_data,
          submitDecisionsLoadingDevelopment: false,
          submitDecisionsLoadingMarketing: false,
          submitDecisionsLoadingOperations: false,
          submitDecisionsLoadingFinance: false
        });
      })
      .catch(err => {});
  };

  submitDecisions = type => {
    const t = capitalizeFirstLetter(type);
    this.setState({
      [`submitDecisionsLoading${t}`]: true
    });

    submitDecisions(type, this.props.roundInUrl || this.props.currentRound, () => this.getSubmissionData(t));
  };

  getSubmissionData = type => {
    this.setState({
      [`submitDecisionsLoading${type}`]: true
    });

    this.fetchData();
  };

  get showActionButtons() {
    const { hasAccess } = this.state;
    const {
      roundShouldBeFinished,
      roundInUrl,
      currentRound,
      rounds
    } = this.props;

    if (!rounds) {
      return false;
    }

    if (hasAccess === false) {
      return false;
    }

    if (roundShouldBeFinished === true) {
      return false;
    }

    if (roundInUrl !== null && roundInUrl !== currentRound) {
      return false;
    }

    const round = rounds.find(i => i.number === currentRound);

    if (!round) {
      return false;
    }

    return round.is_started === true && round.is_finished === false;
  }

  render() {
    console.log("props", this.props);

    return (
      <div>
        <DecisionsWrapper
          location={window.location}
          position={this.props.position}
          breadcrumbsTitle={this.props.location.pathname}
        />
      </div>
    );
  }
}

export default DecisionsSummary;



// WEBPACK FOOTER //
// ./src/containers/decisions-summary.js